import React, { useState } from 'react';

const ForwardIcon = ({
  width = 32,
  height = 32,
  color = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  hoverColor = 'var(--ca-theme-palette-colors-controlButtonColorHover, #29132e)',
  className = '',
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <circle cx="16" cy="16" r="16" fill={isHovered ? hoverColor : color} />
      <path
        d="M20.7773 15.5676L17.4021 12.7549C17.04 12.4543 16.4792 12.7057 16.4792 13.1874V18.8126C16.4792 19.2943 17.04 19.5474 17.4021 19.2451L20.7773 16.4325C21.0462 16.2074 21.0462 15.7926 20.7773 15.5676ZM16.2771 15.5676L12.9019 12.7549C12.5398 12.4543 11.979 12.7057 11.979 13.1874V18.8126C11.979 19.2943 12.5398 19.5474 12.9019 19.2451L16.2771 16.4325C16.546 16.2074 16.546 15.7926 16.2771 15.5676Z"
        fill="white"
      />
    </svg>
  );
};

export default ForwardIcon;
